(function() {
    var __webpack_require__ = {};
    !function() {
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
    }();
    var __webpack_exports__ = {};
    !function() {
        (function() {
            class VariantStatusBadge extends HTMLElement {
                constructor() {
                    super();
                    this.form = null;
                    this.statusScript = null;
                    this.variantStatusMap = {};
                    this.handleVariantChange = this.handleVariantChange.bind(this);
                }
                connectedCallback() {
                    const formId = this.getAttribute("form");
                    this.form = formId ? document.forms[formId] : null;
                    this.statusScript = document.querySelector("script[data-variant-status]");
                    this.variantStatusMap = this.parseVariantStatusMap();
                    this.comingSoonText = this.getAttribute("coming-soon-text") || "Coming Soon";
                    this.preOrderText = this.getAttribute("pre-order-text") || "Pre-order";
                    if (this.form) {
                        this.form.addEventListener("variant:change", this.handleVariantChange);
                    }
                }
                disconnectedCallback() {
                    if (this.form) {
                        this.form.removeEventListener("variant:change", this.handleVariantChange);
                    }
                }
                parseVariantStatusMap() {
                    if (!this.statusScript) {
                        return {};
                    }
                    try {
                        return JSON.parse(this.statusScript.textContent);
                    } catch (error) {
                        return {};
                    }
                }
                handleVariantChange(event) {
                    const variant = event.detail && event.detail.variant;
                    if (!variant) {
                        return;
                    }
                    const variantId = variant.id.toString();
                    const variantData = this.variantStatusMap[variantId];
                    if (!variantData) {
                        this.innerHTML = "";
                        return;
                    }
                    this.innerHTML = this.buildBadgeHtml(variantData);
                }
                buildBadgeHtml(variantData) {
                    const status = variantData.status;
                    const available = variantData.available;
                    if (status === "Coming-soon" && !available) {
                        return '<span class="badge badge--primary badge--coming-soon">' + this.comingSoonText + "</span>";
                    }
                    if (status === "Pre-order" && available) {
                        return '<span class="badge badge--primary badge--pre-order">' + this.preOrderText + "</span>";
                    }
                    return "";
                }
            }
            if (!customElements.get("variant-status-badge")) {
                customElements.define("variant-status-badge", VariantStatusBadge);
            }
        })();
    }();
    !function() {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
    }();
})();